import React from 'react';
import { useHistory } from 'react-router-dom';
import { string } from 'prop-types';

import { Icon } from '@atoms';
import { Typography, Flex, Button } from '@mixins';
import { theme } from '@styles';
import { routes } from '@constants';
import { getCurrency } from '@helpers/common';

import { ReactComponent as ReferFriendIcon } from '@assets/svgs/ReferFriend.svg';

const ReferFriend = ({ currency, amount }) => {
  const history = useHistory();
  
  const onReferFriend = () => {
   history.push(routes.referFriend);
  };

  return (
    <Flex
      mb={[60, 100, 140]}
      border="1px solid #D9D9D9"
      py={[25, 35, 45]}
      px={[30, 60, 90]}
      alignItems="center"
      justifyContent="space-between"
      width={[360, 600, 800, 990]}
      height={[120, 185, 230, 280]}
    >
      <Flex flexDirection="column" alignItems="start">
        <Typography mb={['8px', 20]} variant="rightserif-400" fontSize={[20, 32, 40]}>
          It pays to have friends!
        </Typography>
        <Typography mb={['8px', 20]} color={theme.color.gray[500]} variant="diatype-500" fontSize={[10, 16, 20]}>
          Earn up to {getCurrency(currency, Number(amount))}
        </Typography>
        <Button fontSize={[10, 13, 16]} onClick={onReferFriend} variant="primary" py={['6px', 12]} px={[15, 30]}>
          Refer a Friend
        </Button>
      </Flex>
      <Icon width={[90, 140, 190]} SVG={ReferFriendIcon} />
    </Flex>
  );
};

ReferFriend.propTypes = {
  currency: string.isRequired,
  amount: string.isRequired
};

export default ReferFriend;
